// src/lib/googleMapsConfig.ts
import type { Libraries } from '@react-google-maps/api';

/**
 * Configuration unique pour @react-google-maps/api.
 *
 * IMPORTANT:
 * Le bug "Loader must not be called again with different options" arrive lorsque
 * plusieurs pages chargent Google Maps avec des options différentes (id, libraries,
 * language, region). Toutes les pages doivent donc importer CES constantes.
 */
export const GOOGLE_MAPS_SCRIPT_ID = 'google-map-script';
export const GOOGLE_MAPS_LIBRARIES: Libraries = ['places'];
export const GOOGLE_MAPS_LANGUAGE = 'en';
export const GOOGLE_MAPS_REGION = 'US';
export const GOOGLE_MAPS_AUTH_REFERRER_POLICY = 'origin';

export const GOOGLE_MAPS_API_KEY =
  (import.meta as any).env?.VITE_GOOGLE_MAPS_API_KEY || '';
